import React from 'react';
import GameHeader from '../GameHeader/GameHeader';
import './GameIntro.css';

const GameIntro = ({ onStartGame }) => {
  return (
    <div className="champions-league-game">
      <div className="champions-league-background"></div>
      <GameHeader />
      <div className="champions-league-starball"></div>
      
      <div className="game-intro">
        <h1>Champions League Game</h1>
        <p>Velkommen til Champions League spillet! Du skal gætte på:</p>
        <ul>
          <li>Vinderen af Champions League (før sæsonen starter)</li>
          <li>Rækkefølgen af alle 36 hold i ligastillingen</li>
          <li>Vindere af playoff og knockout kampe</li>
          <li>Vinderen af finalen</li>
        </ul>
        <button className="start-game-button" onClick={onStartGame}>
          Start Spil
        </button>
      </div>
    </div>
  );
};

export default GameIntro;
